import React from 'react'
import { BellIcon, Menu } from 'lucide-react'
import { Inline } from '@/components/admin/atoms/layout/Inline'
import { Text } from '@/components/admin/atoms/typography/Text'
import { IconButton } from '@/components/admin/atoms/actions/IconButton'
import { TopBarShell } from '@/components/admin/atoms/layout/TopBarShell'
import { TopBarContent } from '@/components/admin/atoms/layout/TopBarContent'
import { AlertBanner } from '@/components/admin/atoms/feedback/AlertBanner'
import { BreadcrumbLink } from '@/components/admin/atoms/navigation/BreadcrumbLink'
import { BreadcrumbSeparator } from '@/components/admin/atoms/navigation/BreadcrumbSeparator'
import { Spacer } from '@/components/admin/atoms/layout/Spacer'
import { MobileOnly } from '@/components/admin/atoms/layout/MobileOnly'
import { UserMenu } from '@/components/admin/molecules/navigation/UserMenu'
import { useTopBarVM } from './TopBar.vm'

interface BreadcrumbItem {
  label: string
  href?: string
}

interface TopBarProps {
  breadcrumbs?: BreadcrumbItem[]
  onMenuToggle?: () => void
  className?: never
}

export const TopBar: React.FC<TopBarProps> = ({ breadcrumbs = [], onMenuToggle }) => {
  const vm = useTopBarVM()

  return (
    <TopBarShell>
      {vm.notice && (
        <AlertBanner variant="success">{vm.notice}</AlertBanner>
      )}
      {vm.alert && (
        <AlertBanner variant="error">{vm.alert}</AlertBanner>
      )}

      <TopBarContent>
        <Inline gap="1" align="center">
          {onMenuToggle && (
            <MobileOnly>
              <IconButton
                icon={<Menu style={{ width: 20, height: 20 }} />}
                label="Toggle menu"
                variant="ghost"
                size="sm"
                onClick={onMenuToggle}
              />
            </MobileOnly>
          )}
          <BreadcrumbLink href="/admin">Dashboard</BreadcrumbLink>
          {breadcrumbs.map((item, i) => (
            <React.Fragment key={i}>
              <BreadcrumbSeparator />
              {item.href && i < breadcrumbs.length - 1 ? (
                <BreadcrumbLink href={item.href}>{item.label}</BreadcrumbLink>
              ) : (
                <Text size="sm" weight="medium">{item.label}</Text>
              )}
            </React.Fragment>
          ))}
        </Inline>

        <Spacer />

        <Inline gap="3" align="center">
          <IconButton
            icon={<BellIcon style={{ width: 16, height: 16 }} />}
            label="Notifications"
            variant="ghost"
            size="sm"
          />
          <UserMenu
            initials={vm.userInitial}
            open={vm.userMenuOpen}
            onToggle={vm.toggleUserMenu}
            anchorRef={vm.userMenuRef}
          />
        </Inline>
      </TopBarContent>
    </TopBarShell>
  )
}
